import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import NotImage from '../Images/no_avatar.png';
import { GoogleLogin } from 'react-google-login';
import { googlePlus } from 'react-icons-kit/fa/googlePlus'
import { Icon } from 'react-icons-kit'
import { Redirect } from 'react-router-dom';
import LoginLayout from '../layout/loginLayout';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
import { ClipLoader } from 'react-spinners';
import clientIdGoogle from '../utils/clientGoogle.json';
import RolesType from '../utils/roles';
import RolService from '../Services/rolService/rolService';
import AuthService from '../Services/authService/authService';
import jwt_decode from 'jwt-decode';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;


class FormLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAutenticated: false,
      loading: false
    }
    this.signup = this.signup.bind(this);
  }

  signup(res, type) {
    this.setState({
      loading: true
    });
    var postData;
    var that = this;
    if (type === 'google' && res.profileObj.email) {
      postData = {
        name: res.profileObj.name,
        provider: type,
        email: res.profileObj.email,
        provider_id: res.profileObj.googleId,
        token: res.accessToken,
        provider_pic: res.profileObj.imageUrl
      };
    }
    if (postData) {
      var DataResult = AuthService.getAuth(postData.email);
      DataResult.then(function (data) {
        var Usertoken = data.data.token;
        var decoded = jwt_decode(Usertoken);

        if (data && decoded) {          
          sessionStorage.setItem("user", decoded['unique_name']);
          sessionStorage.setItem("token", Usertoken);
          sessionStorage.setItem("email", decoded['unique_name']);
          sessionStorage.setItem("rol", decoded['role']);

          window.validaterequestdata = btoa(decoded['unique_name'] + Usertoken + decoded['unique_name'] + decoded['role']);

          that.setState({
            isAutenticated: true,
            loading: false
          }, () => console.log());
        } else {
          that.setState({
            loading: false,
            isAutenticated: false
          })
          toast.error("User Incorrect!", {
            className: {
              opacity: 0.8
            }
          });
        }
      }).catch((error) => {

        that.setState({
          isAutenticated: false,
          loading: false
        });
        if (error.response) {
          if (error && error.response && error.response.data.Message === "500") {
            toast.error("Error Data Base(Error: 500)", {
              className: {
                opacity: 0.8
              }
            });
          } else if (error && error.response && error.response.data === "NoDB") {
            toast.error("Company Code dosen't exist!", {
              className: {
                opacity: 0.8
              }
            });
          } else if (error && error.response && error.response.data === "NotReseller") {
            toast.error("This User does not have permission!", {
              className: {
                opacity: 0.8
              }
            });
          } else if (error && error.response && error.response.data.Message === "400") {
            toast.error("API Error for Reseller", {
              className: {
                opacity: 0.8
              }
            });
          } else if (error.response.status === 401) {
            sessionStorage.setItem("user", '');
            sessionStorage.setItem("token", '');
            sessionStorage.setItem("rol", '');
            sessionStorage.setItem("email", '');


            sessionStorage.clear();
            this.setState({ isAutenticated: false },
              () => {
                this.forceUpdate();
              })
            toast.error("Invalid User", {
              className: {
                opacity: 0.8
              }
            });
          }
        } else {
          toast.error("Code Error", {
            className: {
              opacity: 0.8
            }
          });
        }
      });

      //--------
      //return (<Redirect to={'/realtime'}/>)  return (<Redirect to={'/home'}/>)

    } else { }
  }

  responseGoogle = (response) => {
    this.signup(response, 'google');
  }



  render() {
    let dataResult = RolesType;
    var temp = Object.keys(dataResult);

    if (this.state.isAutenticated === true && sessionStorage.getItem("rol") === temp[4]) {
      return (<Redirect to={'/device'} />)
    }
    if (this.state.isAutenticated === true && sessionStorage.getItem("rol") !== temp[4]) {
      return (<Redirect to={'/home'} />)
    }

    return (
      <div><LoginLayout />
        <div className="container "><ToastContainer hideProgressBar />
          <div className="row" style={{ 'paddingTop': '100px' }} >
            <div className="col-4 offset-3" >
              <Card >
                <CardBody >
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-3 offset-3" style={{ 'paddingRight': '0px' }}>
                      <img src={NotImage} title="NotImage" alt="" className="rounded-circle" style={{ 'width': '200%' }} />
                    </div>
                  </div>
                  <div className="row" style={{ 'paddingLeft': '35px', 'paddingRight': '10px' }}>
                    {
                      this.state.loading
                        ?
                        <div>
                          <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={30}
                            color={'#3F51B5'}
                            loading={this.state.loading}
                          />

                        </div>
                        :
                        <GoogleLogin
                          clientId={clientIdGoogle.GOOGLE_CLIENT_ID}
                          buttonText="Login"
                          onSuccess={this.responseGoogle}
                          onFailure={this.responseGoogle}
                          className="btn btn-primary"
                        >
                          <div className="row" style={{ 'paddingTop': '5px' }}>
                            <div className="col-1"><Icon icon={googlePlus} size={25} /></div>
                            <div className="col-10" style={{ 'paddingTop': '5px' }}><span> Login with Google</span></div>
                          </div>
                        </GoogleLogin>
                    }
                  </div><br />
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FormLogin;


// WEBPACK FOOTER //
// ./src/login/formLogin.jsx